//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { generateLenderNote, getLenderNoteGenerationSettings, saveLenderNoteGenerationSettings } from "../../../../api/lender-submit-api";
export default defineComponent({
  name: "GenerateNotesModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    mortgageType: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      includeDownPayment: true,
      includeRatios: true,
      includeCreditScores: true,
      includeOtherPropertiesOwned: true,
      includeAssets: false,
      includeLiabilities: false,
      includeReqRateDetails: false,
      includeAll: false,
      language: "en-CA",
      format: "list",
      loading: false,
      loadingSaveSettings: false
    };
  },
  computed: {
    generatedNote: {
      get() {
        return this.$store.state.ApplicationStore.generatedLenderNote;
      },
      set(value) {
        this.$store.commit("ApplicationStore/SET_GENERATED_LENDER_NOTE", value);
      }
    },
    waitingForGeneratedLenderNote: {
      get() {
        return this.$store.state.ApplicationStore.waitingForGeneratedLenderNote;
      },
      set(value) {
        this.$store.commit("ApplicationStore/SET_WAITING_FOR_GENERATED_LENDER_NOTE", value);
      }
    }
  },
  watch: {
    includeAll(newIncludeAll) {
      if (newIncludeAll) {
        this.includeDownPayment = true;
        this.includeRatios = true;
        this.includeCreditScores = true;
        this.includeOtherPropertiesOwned = true;
        this.includeAssets = true;
        this.includeLiabilities = true;
        this.includeReqRateDetails = true;
      }
    }
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    handleElementChange() {
      if (this.includeDownPayment && this.includeRatios && this.includeCreditScores && this.includeOtherPropertiesOwned && this.includeAssets && this.includeLiabilities && this.includeReqRateDetails) {
        this.includeAll = true;
      } else {
        this.includeAll = false;
      }
    },
    // Lender notes interface with the Azure OpenAI API, sometimes the API is slow
    // and it takes >30s to execute, which is the maximum possible AWS API Gateway timeout
    // when that happens the response will come from the websocket connection instead
    async handleGenerateNote() {
      this.waitingForGeneratedLenderNote = true;
      try {
        const result = await generateLenderNote({
          elementsToInclude: {
            downPayment: this.includeDownPayment,
            ratios: this.includeRatios,
            creditScores: this.includeCreditScores,
            otherPropertiesOwned: this.includeOtherPropertiesOwned,
            assets: this.includeAssets,
            liabilities: this.includeLiabilities,
            reqRateDetails: this.includeReqRateDetails
          },
          language: this.language,
          format: this.format
        }, this.mortgageType, this.username, this.clientUsername, this.applicationId);
        this.generatedNote = result.lenderNote;
        this.waitingForGeneratedLenderNote = false;
      } catch (e) {
        this.waitingForGeneratedLenderNote = true;
      }
    },
    async handleSaveSettings() {
      this.loadingSaveSettings = true;
      await saveLenderNoteGenerationSettings({
        elementsToInclude: {
          downPayment: this.includeDownPayment,
          ratios: this.includeRatios,
          creditScores: this.includeCreditScores,
          otherPropertiesOwned: this.includeOtherPropertiesOwned,
          assets: this.includeAssets,
          liabilities: this.includeLiabilities,
          reqRateDetails: this.includeReqRateDetails
        },
        language: this.language,
        format: this.format
      });
      this.loadingSaveSettings = false;
    },
    async loadSettings() {
      this.loadingSaveSettings = true;
      const result = await getLenderNoteGenerationSettings();
      this.includeDownPayment = result.settings.elementsToInclude.downPayment;
      this.includeRatios = result.settings.elementsToInclude.ratios;
      this.includeCreditScores = result.settings.elementsToInclude.creditScores;
      this.includeOtherPropertiesOwned = result.settings.elementsToInclude.otherPropertiesOwned;
      this.includeAssets = result.settings.elementsToInclude.assets;
      this.includeLiabilities = result.settings.elementsToInclude.liabilities;
      this.includeReqRateDetails = result.settings.elementsToInclude.reqRateDetails;
      this.language = result.settings.language;
      this.format = result.settings.format;
      this.loadingSaveSettings = false;
    },
    handleSaveGeneratedNote() {
      var _this$generatedNote;
      this.$emit("note", (_this$generatedNote = this.generatedNote) != null ? _this$generatedNote : "");
      this.$hideModal();
    },
    onOpen() {
      this.generatedNote = "";
      if (this.includeDownPayment && this.includeRatios && this.includeCreditScores && this.includeOtherPropertiesOwned && this.includeAssets && this.includeLiabilities && this.includeReqRateDetails) {
        this.includeAll = true;
      }
    }
  }
});